/* script */

import BaseResource from '../resources/base'
import ResourceEditForm from './ResourceEditForm'

const __vue_script__ = {
    name: 'TrResourceEdit',
    extends: ResourceEditForm,
    props: {
        inline: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: 'Edit',
        },
        noSubmit: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        columnCount() {
            return Object.keys(this.formset).length
        },
    },
}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-tr",
    { staticClass: "resource-edit-table-row" },
    _vm._l(_vm.formset, function(field, fieldkey) {
      return _c(
        "b-td",
        { key: fieldkey, staticClass: "resource-edit-table-cell" },
        [
          _vm._t(
            "field-" + fieldkey,
            [
              _vm._t("field-control-before-" + fieldkey, null, {
                field: field,
                resource: _vm.resource
              }),
              _vm._v(" "),
              _vm._t(
                "field-control-" + fieldkey,
                [
                  _c(
                    field.component,
                    _vm._b(
                      {
                        ref: "field-" + fieldkey,
                        refInFor: true,
                        tag: "component",
                        attrs: {
                          field: field,
                          readonly: _vm.readonly,
                          keyname: fieldkey,
                          resource: _vm.resource,
                          size: _vm.size,
                          "resource-form": _vm.getFormContext()
                        },
                        on: { keydown: _vm.onKeyDown },
                        model: {
                          value: _vm.resource.attributes[fieldkey],
                          callback: function($$v) {
                            _vm.$set(_vm.resource.attributes, fieldkey, $$v)
                          },
                          expression: "resource.attributes[fieldkey]"
                        }
                      },
                      "component",
                      field.props,
                      false
                    )
                  )
                ],
                { field: field, resource: _vm.resource }
              ),
              _vm._v(" "),
              _vm._t(
                "field-control-after-" + fieldkey,
                [
                  field.options.description && !_vm.inline
                    ? _c("small", [_vm._v(_vm._s(field.options.description))])
                    : _vm._e()
                ],
                { field: field, resource: _vm.resource }
              )
            ],
            { field: field, resource: _vm.resource }
          )
        ],
        2
      )
    }),
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-395dbdea_0", { source: ".resource-edit-table-row .form-control {\n  border-radius: 0 !important;\n  border: none;\n  padding: 0;\n  margin: 0;\n  height: inherit;\n}\n.resource-edit-table-row .icons {\n  display: none;\n}\n.resource-edit-table-row .resource-edit-table-cell {\n  border-width: 1px;\n}\n\n", map: "AA2DA;EACA,2BAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AA1DA;AA6DA;EACA,aAAA;AA3DA;AA8DA;EACA,iBAAA;AA5DA;;AAEA,4CAA4C", media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = undefined
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "/src/components/TrResourceEdit.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/components/TrResourceEdit.js
// module id = ts+Q
// module chunks = 0